import React from "react";
import ambulance1 from "../assets/img/amblunce1.png";
import ambulance2 from "../assets/img/amblunce2.png";

function Services({ openPopup }) {
  const servicesData = [
    {
      title: "ICU Ambulance",
      description:
        "IHU's ICU Ambulance Service ensures rapid and efficient emergency medical transportation across all over India. We recognize the critical nature of emergencies and are dedicated to offering top-tier, round-the-clock service. Our highly equipped ambulances guarantee swift patient transfers to medical facilities, operating seamlessly at any hour, including midnight, covering all regions across India when needed.",
      imgSrc: ambulance1,
      imgAlt: "ICU Ambulance",
      reverse: true,
    },
    {
      title: "Non-ICU Ambulance",
      description:
        "Our Non-ICU Ambulance Service provides timely and reliable medical transport for non-critical patients all over India. We ensure fast response times and safe transfers, catering to patients who require urgent but non-emergency transportation. Available 24/7, our service covers all locations across India, ensuring seamless patient relocations whenever required.",
      imgSrc: ambulance2,
      imgAlt: "Non-ICU Ambulance",
      reverse: false,
    },
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="our-services">
          <h1 className="fade-out fade-in ">Our Ambulance Services</h1>
          <h6 className="fade-out fade-in ">
            Trust IHU (Indian Health Unit) for swift and dependable ambulance services.
          </h6>

          {servicesData.map((service, index) => (
            <div key={index} className={`row ${service.reverse ? "column-reverse" : ""}`}>
              <div className="col6">
                {service.reverse ? (
                  <>
                    <h5 className="fade-out fade-in">{service.title}</h5>
                    <p className="fade-out fade-in">{service.description}</p>
                    <button className="btn-null btn-primary fade-out fade-in fade-out-right" onClick={openPopup}>
                      Book Now <i className="fa-solid fa-angle-right"></i>
                    </button>
                  </>
                ) : (
                  <img className="fade-out fade-in " src={service.imgSrc} alt={service.imgAlt} />
                )}
              </div>
              <div className="col6">
                {service.reverse ? (
                  <img className="fade-out fade-in " src={service.imgSrc} alt={service.imgAlt} />
                ) : (
                  <>
                    <h5 className="fade-out fade-in ">{service.title}</h5>
                    <p className="fade-out fade-in ">{service.description}</p>
                    <button className="btn-null btn-primary fade-out fade-in fade-out-right" onClick={openPopup}>
                      Book Now <i className="fa-solid fa-angle-right"></i>
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
